const REPORTING_ADD_ACCOUNTS_CALLOUT_KEY = 'isReportingPageAddAccountsCalloutDismissed';

export const reportingCalloutStorage = {
  key: REPORTING_ADD_ACCOUNTS_CALLOUT_KEY,
  getDismissed: (): boolean => {
    try {
      return localStorage.getItem(REPORTING_ADD_ACCOUNTS_CALLOUT_KEY) === 'true';
    } catch {
      return false;
    }
  },
  setDismissed: (dismissed: boolean): void => {
    try {
      localStorage.setItem(REPORTING_ADD_ACCOUNTS_CALLOUT_KEY, dismissed ? 'true' : 'false');
    } catch {
      // ignore storage errors (e.g. in private mode)
    }
  },
  clear: (): void => {
    try {
      localStorage.removeItem(REPORTING_ADD_ACCOUNTS_CALLOUT_KEY);
    } catch {
      // ignore
    }
  },
};
